import Plyr from 'plyr'
import { trace } from "rytm-helpers"
import ImageViewer from 'iv-viewer'


let viewer, player
let wcagZoomState = {
  zoom: 100,
  p: {
    x: 0,
    y: 0,
  }
}

export const destroyObjectImage = () => {
  if (viewer) {
    viewer.destroy()
    viewer = null
  }
  destroyWcagZoomControls()
}

export const initObjectImage = () => {
  destroyObjectImage()
  const container = document.querySelector('.object-media-image')
  if (container) {
    initImageViewer(container)
    initWcagZoomControls()
  }
}

export const destroyObjectVideo = () => {
  if (player) {
    player.destroy()
    player = null
  }
}
export const initObjectVideo = () => {
  player = new Plyr('.u-video');
}

export const updateObjectMedia = () => {
  trace("update object media");
  destroyObjectImage()
  initObjectImage()
  destroyObjectVideo()
  initObjectVideo()
}

// init wcag zoom controls
const initWcagZoomControls = () => {
  const zoomIn = document.querySelector(".wcag-zoom-tools .zoom-in")
  if (zoomIn) {
    zoomIn.addEventListener("click", onZoomIn)
  }
  const zoomOut = document.querySelector(".wcag-zoom-tools .zoom-out")
  if (zoomOut) {
    zoomOut.addEventListener("click", onZoomOut)
  }
  // add keys
  document.addEventListener("keydown", onKeydown)
}
// destroy wcag zoom controls
const destroyWcagZoomControls = () => {
  const zoomIn = document.querySelector(".wcag-zoom-tools .zoom-in")
  if (zoomIn) {
    zoomIn.removeEventListener("click", onZoomIn)
  }
  const zoomOut = document.querySelector(".wcag-zoom-tools .zoom-out")
  if (zoomOut) {
    zoomOut.removeEventListener("click", onZoomOut)
  }
  document.removeEventListener("keydown", onKeydown)
}
const WCAG_ZOOM_STEP = 20
const WCAG_ZOOM_P_STEP = 10
const WCAG_ZOOM_MAX = 300
const onZoomIn = (e) => {
  e.preventDefault()
  if (viewer) {
    wcagZoomState.zoom = wcagZoomState.zoom + WCAG_ZOOM_STEP
    wcagZoomState.zoom = wcagZoomState.zoom > WCAG_ZOOM_MAX ? WCAG_ZOOM_MAX : wcagZoomState.zoom
    viewer.zoom(wcagZoomState.zoom, wcagZoomState.p)
  }
}
const onZoomOut = (e) => {
  e.preventDefault()
  if (viewer) {
    wcagZoomState.zoom = wcagZoomState.zoom - WCAG_ZOOM_STEP
    wcagZoomState.zoom = wcagZoomState.zoom < 100 ? 100 : wcagZoomState.zoom
    viewer.zoom(wcagZoomState.zoom, wcagZoomState.p)
  }
}

const onKeydown = (e) => {
  const step = WCAG_ZOOM_P_STEP * WCAG_ZOOM_STEP
  switch (e.key) {
    case "+":
    case "=":
      wcagZoomState.zoom = wcagZoomState.zoom + WCAG_ZOOM_STEP
      wcagZoomState.zoom = wcagZoomState.zoom > WCAG_ZOOM_MAX ? WCAG_ZOOM_MAX : wcagZoomState.zoom
      break;
    case "-":
    case "_":
      wcagZoomState.zoom = wcagZoomState.zoom - WCAG_ZOOM_STEP
      wcagZoomState.zoom = wcagZoomState.zoom < 100 ? 100 : wcagZoomState.zoom
      break;
    case "ArrowUp":
      wcagZoomState.p.y = wcagZoomState.p.y - step
      break;
    case "ArrowDown":
      wcagZoomState.p.y = wcagZoomState.p.y + step
      break;
    case "ArrowLeft":
      wcagZoomState.p.x = wcagZoomState.p.x - step
      break;
    case "ArrowRight":
      wcagZoomState.p.x = wcagZoomState.p.x + step
      break;
  }
  if (viewer) {
    viewer.zoom(wcagZoomState.zoom, wcagZoomState.p)
  }
}

// init iv
const initImageViewer = (container) => {
  const imgLow = container.dataset.imgLow
  const imgHigh = container.dataset.imgHigh
  const imgAlt = container.dataset.imgAlt
  if (imgLow) {
    const options = {
      zoomValue: 100,
      snapView: true,
    }
    viewer = new ImageViewer(container, options)
    viewer.load(imgLow, imgHigh) 
    let cc = 0
    const max = 10
    let interval = setInterval(() => {
      cc++
      if (cc >= max) {
        clearInterval(interval)
      }
      const list = [...document.querySelectorAll(".object-media-image .iv-image-wrap .iv-image")]
      list.forEach((img) => {
        img.alt = imgAlt
      })
    }, 300)
  }
}